import React, { useState } from "react";
import styled from "styled-components";
import IUMRSNavBar from '../events/iumrs-icam25/IUMRSNavbar.jsx';
import { ICAMNavroute } from '../../utils/ICAMnavroute.js';
import IUMRSFooter from "../events/iumrs-icam25/IUMRSFooter.jsx";
import axios from "axios";
import { X } from "lucide-react";
import { useDesktopSiteDetection } from "../../hooks/mobile_desktop_mode.jsx";

const BackendUrl = "https://amrs-prod.eu-north-1.elasticbeanstalk.com"

const PaymentInitialization = () => {
    const [email1, setEmail1] = useState('');
    const [eventType, setEventType] = useState('');
    const [subDirectory, setSubDirectory] = useState('');
    const [loading1, setLoading1] = useState(false);
    const [error, setError] = useState('');
    const isDesktopSiteOnMobile = useDesktopSiteDetection()

    const route = { 
        route1 : "/event/conference/iumrs-icam2025/payment-request", 
        route2 : "/event/workshop/amrs-jun-2026-workshop/payment-request",
        route3 : "/event/workshop/amrs-dec-2026-workshop/payment-request"  //Needs to be updated to new slug name
    }

    const storeReference = (reference) => {
        localStorage.setItem('amrsghana_payRef', reference);
      };

    const handleChange = (e) => {
        const selectedKey = e.target.value;

        setEventType(selectedKey);
        setSubDirectory(route[selectedKey]);
    }
    
    const routetoPayment = async (e) => {
        e.preventDefault();
        setError('');
        
        if (!eventType) {
            setError("Please choose the event to be verified");
            return;
        }

        if (!email1.trim()) {
            setError("Please enter a valid email.");
            return;
        }

        

        setLoading1(true);
        try { 
            const PayInitializationResponse = await axios.post(
                `${BackendUrl}${subDirectory}`,
                { email: email1 },
                {
                    headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
                    timeout: 5000
                }
            );
            
        } catch (err) {

            if (err.response && err.response.status === 301) {
                const { payment_url, reference } = err.response.data;
                storeReference(reference);
                window.location.href = payment_url;
            } else if (err.response && err.response.status === 422){
                setError("Not a valid email address")
            } else if (err.response && err.response.status === 400){
                setError(err.response.data.message)
            }
            else {
                // Handle all other errors
                setError("Please confirm your email and try again. Otherwise contact support");
            }
            
        } finally {
            setLoading1(false);
        }
    };



    return (
        <Wrapper>
            <Container className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>
                <Card>
                    <button className="cancel-button"
                              style={{color: "rgba(233, 31, 31, 1)", position:"absolute", right:"2rem", top:"2rem", borderRadius: "5px", borderColor: "rgba(233, 31, 31, 1)",backgroundColor:"#f4f6f9"}}
                              onClick={() => (window.history.back())}
                              >
                              <X size={20} /> 
                    </button>
                    <Title>Payment Initializer</Title>
                    
                    <Label>Please enter the email used for successful event registration to begin payment processing.</Label>
                    <Form onSubmit={routetoPayment}>

                        <select name="category" value={eventType} onChange={handleChange} 
                              required>
                            <option className="placeholder" value="" disabled>Please select the event</option>
                            <option value="route1">IUMRS-ICAM Conference 2025</option>
                            <option value="route2">AMRS-UG June Workshop 2026 </option>
                            <option value="route3">AMRS-UG December Workshop 2026 </option>
                        </select>
                        <Input 
                            type="email" 
                            value={email1} 
                            onClick={() =>error && setError('')}
                            onChange={(e) => setEmail1(e.target.value)} 
                            required 
                            placeholder="Enter email address" 
                            disabled={loading1}
                        />
                        {error && <ErrorBox>{error}</ErrorBox>}
                        <Button type="submit" disabled={loading1} onClick={routetoPayment}>
                            {loading1 ? 'Processing...' : 'Initialize payment'}
                        </Button>
                    </Form>
                    <Divider />
                    <Verification>
                        <Label>Already made payment?</Label>
                        <button onClick={() => (window.location.href = "/event/payment-verification")}>
                            Verify transaction
                        </button>
                    </Verification>
                </Card>
            </Container>

        </Wrapper>
    );
};

const Wrapper = styled.div`
    background-color: #f4f6f9;
      min-height: 100vh;
`;

const Verification = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  button {
    background-color: #2563eb; /* Same blue as 'Initialize Payment' */
    color: white;
    margin-top: 1em;
    border: none;
    padding: 0.7rem 1.2rem;
    font-size: 1rem;
    border-radius: 5px;
    cursor: pointer;
    transition: background 0.3s ease-in-out;
    
    &:hover {
      background-color: #1d4ed8;
    }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  background-color:#f4f6f9;
  padding: 2rem;

  @media only screen and (min-width: 840px){
    min-height: 85vh;
  }

  &.desktop-site-mode{
    min-height: 68vh;
  }
`

const Card = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 400px;
  width: 100%;
`;

const Title = styled.h2`
  color: #2c3e50;
  margin-bottom: 1.5rem;
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 1em;
    margin-top: 1em;

    select {
    margin-top: 1rem;
    height: 42px; padding: 0 14px;
    border: 1px solid #ddd; border-radius: 5px;
    font-size: 16px; color: #4d3333ff; width: 100%;
    outline: none; transition: border-color 0.2s, box-shadow 0.2s;

    &:focus { border-color: #0c4e80; box-shadow: 0 0 0 3px rgba(12,78,128,0.08); }
`;

const Label = styled.label`
    font-weight: 500;
    color:rgb(177, 34, 34);
    margin-top: 3rem;
`;

const Input = styled.input`
    height: 42px;
    margin-top: 0.7rem;
    padding: 0 14px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 16px;
    color: #4d3333ff;

    &:focus { outline: none; border-color: #0c4e80; box-shadow: 0 0 0 3px rgba(12,78,128,0.08); }

`;

const Button = styled.div`
    background-color: ${props => props.variant === 'green' ? '#16a34a' : '#2563eb'};
    color: white;
    min-width: 5rem;
    padding: 12px;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    cursor: pointer;
    transition: 0.3s;
    
    &:hover {
        background-color: ${props => props.variant === 'green' ? '#15803d' : '#1d4ed8'};
    }
    
    &:disabled {
        background-color: #94a3b8;
        cursor: not-allowed;
    }
`;

const Divider = styled.hr`
    border: none;
    height: 1px;
    background: #ddd;
    margin: 2em 0em 0em 0;
`;

const ErrorBox = styled.div`
    margin-top: 1em;
    padding: 1em;
    background: #fee2e2;
    border-radius: 5px;
    color: #b91c1c;
    font-weight: bold;
`;

export default PaymentInitialization;